(function (window, document) {
  'use strict';

  var mapInstance = null;
  var mapboxPromise = null;
  var MAP_STYLE = 'mapbox://styles/mapbox/streets-v11';
  var resizeHandler = null;
  var ric = window.requestIdleCallback || function (cb) { return setTimeout(cb, 0); };

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('script[src="' + src + '"]')) {
        resolve();
        return;
      }
      var s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function loadStyle(href) {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('link[href="' + href + '"]')) {
        resolve();
        return;
      }
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.onload = resolve;
      l.onerror = reject;
      document.head.appendChild(l);
    });
  }

  function loadMapboxAssets() {
    if (!mapboxPromise) {
      mapboxPromise = Promise.all([
        loadScript('https://api.tiles.mapbox.com/mapbox-gl-js/v2.14.1/mapbox-gl.js'),
        loadStyle('https://api.tiles.mapbox.com/mapbox-gl-js/v2.14.1/mapbox-gl.css')
      ]);
    }
    return mapboxPromise;
  }

  window.loadMapboxAssets = loadMapboxAssets;

  function throttle(fn) {
    var running = false;
    return function () {
      if (running) {
        return;
      }
      running = true;
      var args = arguments;
      requestAnimationFrame(function () {
        running = false;
        fn.apply(null, args);
      });
    };
  }

  function initializeMap(canvas) {
    if (mapInstance) {
      return;
    }
    loadMapboxAssets().then(function () {
      var lat = parseFloat(canvas.getAttribute('data-lat'));
      var lng = parseFloat(canvas.getAttribute('data-lng'));
      if (!window.mapboxgl || !window.mapBoxApiKey) {
        return;
      }
      window.mapboxgl.accessToken = window.mapBoxApiKey;
      var options = Object.assign({}, { style: MAP_STYLE }, {
        container: canvas,
        center: [lng, lat],
        zoom: 11
      });
      ric(function () {
        mapInstance = new window.mapboxgl.Map(options);
        mapInstance.on('load', function () {
          mapInstance.addControl(new window.mapboxgl.NavigationControl());
          if (!isNaN(lat) && !isNaN(lng)) {
            new window.mapboxgl.Marker().setLngLat([lng, lat]).addTo(mapInstance);
          }
          resizeHandler = throttle(function () { mapInstance.resize(); });
          window.addEventListener('resize', resizeHandler);
          mapInstance.on('remove', function () {
            window.removeEventListener('resize', resizeHandler);
          });
        });
      });
    });
  }

  function setupObserver() {
    var canvas = document.querySelector('.map-canvas[data-mapbox="true"]');
    if (!canvas) {
      return;
    }
    if ('IntersectionObserver' in window) {
      var io = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            io.disconnect();
            initializeMap(canvas);
          }
        });
      }, { threshold: 0 });
      io.observe(canvas);
    } else {
      ric(function () { initializeMap(canvas); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }

})(window, document);
